import React from "react";
import { ReactComponent as Sun } from "./Sun.svg";
import { ReactComponent as Moon } from "./Moon.svg";
import "./DarkMode.css";

const DarkMode = ({ isDark, toggleTheme }) => {
    return (
        <div className="dark_mode">
            <input
                type="checkbox"
                id="darkmode-toggle"
                className="dark_mode_input"
                checked={isDark}
                onChange={toggleTheme}
            />
            <label className="dark_mode_label" htmlFor="darkmode-toggle">
                <Sun className="sun" />
                <Moon className="moon" />
            </label>
        </div>
    );
};

export default DarkMode;
